import _ from 'underscore';
import odata from '@bingads-webui-component-legacy/http/channel/odata';
import config from '@bingads-webui-component-legacy/config/index';

const langCodeMapper = {
  bg: 'Bulgarian',
  bs: 'Bosnian',
  cs: 'Czech',
  da: 'Danish',
  de: 'German',
  el: 'Greek',
  en: 'English',
  es: 'Spanish',
  et: 'Estonian',
  fi: 'Finnish',
  fr: 'French',
  hr: 'Croatian',
  hu: 'Hungarian',
  is: 'Icelandic',
  it: 'Italian',
  lt: 'Lithuanian',
  lv: 'Latvian',
  mk: 'Macedonian',
  mt: 'Maltese',
  nl: 'Dutch',
  no: 'Norwegian',
  pl: 'Polish',
  pt: 'Portuguese',
  ro: 'Romanian',
  sk: 'Slovak',
  sl: 'Slovenian',
  sq: 'Albanian',
  sr: 'Serbian',
  sv: 'Swedish',
  tr: 'Turkish',
  zh: 'TraditionalChinese',
};

export function detectLanguage(texts) {
  const str = texts.join(',');
  const currentAccount = config.get('CurrentAccount') || {};
  const currentCustomer = config.get('CurrentCustomer') || {};
  const url = `/Customers(${currentCustomer.Id})/Accounts(${currentAccount.Id})/LanguageDetects`;

  return odata.post(url, {
    data: {
      StringToDetectLanguage: str,
    },
  }).then((data) => {
    if (!_.isEmpty(data)) {
      const value = _.result(data, 'value');

      return langCodeMapper[value.toLowerCase()] || langCodeMapper[value.toLowerCase().split('-')[0]];
    }
    return data;
  })
    .catch(() => null);
}
